export const comments_3358640 = {"data":{"data":[],"links":{}}}